import { OnInit, EventEmitter } from '@angular/core';
import { AssessmentService } from '../services/assessment.service';
import { AssessmentTokenService } from '../services/assessment-token.service';
import { AuthService } from 'app/login/services/auth.service';
import { Capability } from '../models/capability';
var AssessmentPickerComponent = /** @class */ (function () {
    function AssessmentPickerComponent(assessmentService, assessmentTokenService, authService) {
        this.assessmentService = assessmentService;
        this.assessmentTokenService = assessmentTokenService;
        this.authService = authService;
        this.selected = new EventEmitter();
        this.buy = new EventEmitter();
        this._loadedTokens = false;
    }
    Object.defineProperty(AssessmentPickerComponent.prototype, "tokensEnabled", {
        get: function () {
            return this.assessmentTokenService.isTokensEnabled();
        },
        enumerable: true,
        configurable: true
    });
    AssessmentPickerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.authService.getCurrentUser().then(function (currentUser) {
            _this._canBuy = currentUser.hasCapability(Capability.CAN_SHOP);
            _this.assessmentService.getAssessmentList().then(function (assessments) {
                _this._assessments = assessments;
                return assessments;
            })
                .then(function (assessments) {
                return _this.assessmentTokenService.loadAssessmentTokens().then(function () {
                    _this._loadedTokens = true;
                });
            });
        })
            .catch(function (error) {
            // TODO: stephen do we need to do something with the current user here?
            console.error(error);
        });
    };
    AssessmentPickerComponent.prototype.getRemainingTokens = function (assessment) {
        if (!this._loadedTokens) {
            return 0;
        }
        return this.assessmentTokenService.getRemainingTokens(assessment);
    };
    AssessmentPickerComponent.prototype.shouldBuyTokens = function (assessment) {
        if (!this._loadedTokens) {
            return false;
        }
        return this._canBuy && this.assessmentTokenService.getRemainingTokens(assessment) <= 0;
    };
    Object.defineProperty(AssessmentPickerComponent.prototype, "hasLoaded", {
        get: function () {
            return this._loadedTokens;
        },
        enumerable: true,
        configurable: true
    });
    AssessmentPickerComponent.prototype.pickAssessment = function (assessment) {
        console.log("selecting ", assessment);
        this.selected.emit(assessment);
    };
    Object.defineProperty(AssessmentPickerComponent.prototype, "assessments", {
        get: function () {
            return this._assessments;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssessmentPickerComponent.prototype, "search", {
        get: function () {
            return this._search;
        },
        set: function (v) {
            this._search = v;
        },
        enumerable: true,
        configurable: true
    });
    AssessmentPickerComponent.prototype.doSearch = function () {
        alert("not implemented yet");
    };
    AssessmentPickerComponent.prototype.resetSearch = function () {
        alert("not implemented yet");
    };
    AssessmentPickerComponent.prototype.enterKeySearch = function (event) {
        alert("not implemented yet");
    };
    AssessmentPickerComponent.prototype.triggerBuy = function (item) {
        this.buy.emit(item);
    };
    return AssessmentPickerComponent;
}());
export { AssessmentPickerComponent };



// WEBPACK FOOTER //
// ./src/app/shared/assessment-picker/assessment-picker.component.ts.pre-build-optimizer.js